export const WAVE_COMPONENTS: ReadonlyArray<readonly [number, number, number, number, number]> = [
  [0.84, 0.54, 0.05, 0.52, 0.72],
  [-0.35, 0.94, 0.082, 0.28, 1.05],
  [0.12, 0.99, 0.14, 0.12, 1.62],
  [-0.91, 0.42, 0.22, 0.05, 2.25],
];

export function sampleWaveHeight(x: number, z: number, time: number): number {
  return WAVE_COMPONENTS.reduce((sum, [dx, dz, frequency, amplitude, speed]) => {
    const length = Math.hypot(dx, dz);
    return sum + Math.sin((x * dx / length + z * dz / length) * frequency + time * speed) * amplitude;
  }, 0);
}

export function shortestAngleDelta(from: number, to: number): number {
  return Math.atan2(Math.sin(to - from), Math.cos(to - from));
}

export function relativeWindFactor(heading: number, windX: number, windZ: number): number {
  const forwardX = Math.sin(heading);
  const forwardZ = Math.cos(heading);
  const length = Math.max(Math.hypot(windX, windZ), 0.0001);
  const alignment = forwardX * windX / length + forwardZ * windZ / length;
  return Math.max(0.34, Math.min(1, 0.63 + alignment * 0.37));
}

export function seededRandom(seed: number): { seed: number; value: number } {
  const nextSeed = (seed * 16807) % 2147483647;
  return { seed: nextSeed, value: (nextSeed - 1) / 2147483646 };
}

export function applyDamage(hull: number, sails: number, amount: number): { hull: number; sails: number } {
  return {
    hull: Math.max(0, hull - amount),
    sails: Math.max(0, sails - amount * 0.24),
  };
}

export function isOutsideCircle(x: number, z: number, centerX: number, centerZ: number, radius: number): boolean {
  return Math.hypot(x - centerX, z - centerZ) >= radius;
}

// The authored ship meshes face the opposite local broadside convention from
// the simulation's +right vector. Keep this mapping centralized so player and
// AI fire use the same nautical port/starboard labels.
export function broadsideSideSign(side: 'port' | 'starboard'): -1 | 1 {
  return side === 'port' ? 1 : -1;
}
